/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessRequestAccess } from "../funcs/accessRequestAccess.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RequestAccessResult } from "../models/components/requestaccessresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  RequestAccessRequest,
  RequestAccessSecurity,
} from "../models/operations/requestaccess.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RequestAccessMutationVariables = {
  request: RequestAccessRequest;
  security?: RequestAccessSecurity | undefined;
  options?: RequestOptions;
};

export type RequestAccessMutationData = RequestAccessResult;

export type RequestAccessMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * requestAccess access
 *
 * @remarks
 * Request access to a scope by sending an email notification to organization administrators.
 */
export function useRequestAccessMutation(
  options?: MutationHookOptions<
    RequestAccessMutationData,
    RequestAccessMutationError,
    RequestAccessMutationVariables
  >,
): UseMutationResult<
  RequestAccessMutationData,
  RequestAccessMutationError,
  RequestAccessMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRequestAccessMutation(client, options),
    ...options,
  });
}

export function mutationKeyRequestAccess(): MutationKey {
  return ["@gram/client", "access", "requestAccess"];
}

export function buildRequestAccessMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RequestAccessMutationVariables,
  ) => Promise<RequestAccessMutationData>;
} {
  return {
    mutationKey: mutationKeyRequestAccess(),
    mutationFn: function requestAccessMutationFn({
      request,
      security,
      options,
    }): Promise<RequestAccessMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(accessRequestAccess(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
